export default "__VITE_ASSET__f6815f76__"